// Custom script for mobile menu dropdown on navigation.liquid
function openCurrencyDropdown() {
	document.getElementById("myDropdown").classList.toggle("show");
  }
  
  // Close the dropdown if the user clicks outside of it
  window.onclick = function(event) {
	if (!event.target.matches('.dropbtn-currency')) {
	  var dropdowns = document.getElementsByClassName("currency-dropdown-content");
	  var i;
	  for (i = 0; i < dropdowns.length; i++) {
		var openDropdown = dropdowns[i];
		if (openDropdown.classList.contains('show')) {
		  openDropdown.classList.remove('show');
		}
	  }
	}
  }
  function openAssistanceDropdown() {
	document.getElementById("myDropdownTwo").classList.toggle("show");
  }
  
  // Close the dropdown if the user clicks outside of it
  window.onclick = function(event) {
	if (!event.target.matches('.dropbtn-assistance')) {
	  var dropdowns = document.getElementsByClassName("assistance-dropdown-content");
	  var i;
	  for (i = 0; i < dropdowns.length; i++) {
		var openDropdown = dropdowns[i];
		if (openDropdown.classList.contains('show')) {
		  openDropdown.classList.remove('show');
		}
	  }
	}
  }
  
  // Currency selector logic
  
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  // Calculate the progress number, and the width of the progress bar. Compiled to ES5.
function calculateProgress(currentVal, targetVal) {
    var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
    var progressNum = document.querySelectorAll('.cart-shipping__num');
    var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
    var successMsg = document.querySelectorAll('.cart-shipping__success');
    // calculate how far progress is from the total as a percentage
    var result = Math.round(100 * currentVal / targetVal);
    progressBar.forEach(function(el){
      el.setAttribute('style', "width: ".concat(result, "%"));
    })
     // Update the progess text. If threshold is met, show success message
    var newProgressNum = ((targetVal - currentVal) / 100).toFixed(2);
    if(newProgressNum <= 0){
      successMsg.forEach(function(el){
        el.setAttribute('style', 'display: block;');
      });
      progressOuter.forEach(function(el){
        el.setAttribute('style', 'display: none;');
      });
      progressNum.forEach(function(el){
        el.textContent = newProgressNum;
      });
    } else {
      successMsg.forEach(function(el){
        el.setAttribute('style', 'display: none;');
      });
      progressOuter.forEach(function(el){
        el.setAttribute('style', 'display: block;');
      });
      progressNum.forEach(function(el){
        el.textContent = newProgressNum;
      });
    }
  };

// Find each ajax call where your store adds to, deletes from, and updates the cart. Put this in the success function of each. 
// NOTE: If this ajax request outside of the functions that update the cart, the calculator won't sync with the current cart state without refreshing the page. You need to specify that you want to read the current cart data AFTER the new items are added/removed.
  $.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function(cart){
    // run the calculator with a target price of $75
    calculateProgress(cart.total_price, 17500);
  }
});

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function detectUserInteraction(){
  document.getElementsByTagName('html')[0].classList.add('js-user-action');

  'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function(e){
      window.removeEventListener(e,detectUserInteraction,false);
  });
}

if( window.mobileCheck() ){

  'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function(e){
      window.addEventListener(e,detectUserInteraction,false);
  });
}else{
  document.getElementsByTagName('html')[0].classList.add('js-user-action');
}

/* ============================================================
   Hobbiesville — Quantity-limit & cart-error net v4
   (toast fallback + clamp + Phase B violation UX + theme error
   cleanup + cart recovery)
   v4 (2026-07-07, Noibu issue #51): toast is now the single message
   surface for ALL /cart 422s (sold-out and inventory rejections
   included, using Shopify's own wording); the theme's popover-error is
   hidden for every cart error, not just limit ones; the LIMIT badge
   only flashes for genuine limit rejections; toast radius 4px -> 7px
   to match the Phase B badge/stepper family.
   v4.1 (same day): cart:add-item dispatch guard added — swallows the
   theme's cart:add-item on pages without [data-cart-toggle], where its
   unguarded listener (this.cartToggle.classList) crashes and the icon
   animation has no target anyway. Runtime substitute for patching
   theme.dev.js; remove when a guarded theme.dev.js (or v7) ships.
   v4.2 (same day): sold-out 422s — toast copy softened to "is now
   sold out" (race-honest wording) and the triggering form's Add to
   Cart button flips to the theme's real disabled Sold Out state
   ([data-add-to-cart][disabled] + theme.translations.sold_out), so a
   stale page stops inviting doomed clicks. Theme-owned add forms only;
   StorePass React buttons stay toast-only until Trent's native build.
   Pairs with the "max-per-order" checkout validation
   (Hobbiesville Ops; custom.quantity_max / quantity_min) and the
   Phase B Liquid (limit badges, [data-hv-limit-cap] inputs,
   [data-hv-limit-alert] box, .hv-limit-note cart notes).
   Phase B handlers are inert on themes without those attributes.
   Removable any time: delete this block.
   ============================================================ */
(function () {
  'use strict';
  if (window.__hvQtyNetV2) return; // guard against double-paste
  window.__hvQtyNetV2 = true;

  var CART_MUTATION = /\/cart\/(add|change|update)/;
  var LIMIT_MSG = /(Limit \d+ per customer|Minimum \d+ per order|Only \d+ per customer)/;
  var lastText = '', lastAt = 0, lastQtyEl = null;

  /* --- TEMPORARY limits map for StorePass-rendered surfaces (collection/search
         grids) where Liquid can't reach. handle → max. Kept in sync by the daily
         audit job; the checkout validation remains the wall, so staleness here is
         cosmetic only. REMOVE this block once StorePass ships native limit
         badges/caps on their cards. Snapshot 2026-07-07. --- */
  var HV_LIMITS = {
    'app-exlusive-pokemon-scarlet-and-violet-destined-rivals-booster-box-pre-order': 2,
    'pokemon-tcg-mega-evolution-set-5-pitch-black-elite-trainer-box-pre-order': 1,
    'pokemon-first-partner-illustration-collections-series-3-pre-order': 4,
    'app-exclusive-pokemon-tcg-mega-evolution-set-5-booster-bundle-max-6-pre-order': 4,
    'mtg-universes-beyond-the-hobbit-gift-bundle-pre-order': 2,
    'pokemon-tcg-mega-evolution-set-5-pitch-black-24-sleeved-pack-bundle-pre-order': 2,
    'app-exclusive-pokemon-tcg-mega-evolution-set-5-pitch-black-booster-box-max-2-pre-order': 2,
    'pokemon-tcg-mega-evolution-set-5-pitch-black-3-pack-blister-pre-order': 4,
    'app-exclusive-wave-2-bundle-pokemon-pitch-black-max-1-per-customer-pre-order': 1,
    'pokemon-tcg-moonlit-tin-bundle-1-of-each-variant-pre-order': 3,
    'wave-2-pokemon-tcg-mega-evolution-set-4-chaos-rising-booster-bundle-pre-order': 12,
    'one-piece-cg-op-13-booster-box-carrying-on-his-will-wave-2-pre-order': 1,
    'pokemon-tcg-mega-set-5-booster-box-pre-order': 1,
    'pokemon-tcg-mega-forces-tin-mega-zeraora-ex-pre-order': 2,
    'pokemon-tcg-mega-forces-tin-mega-darkrai-ex-pre-order': 2,
    'pokemon-tcg-mega-forces-tin-mega-dragonite-ex-pre-order': 2,
    'one-piece-cg-illustration-box-vol-10-pre-order': 2,
    'pokemon-ascended-heroes-tin-mega-feraligatr-ex-pre-order': 2,
    'pokemon-ascended-heroes-tin-mega-emboar-ex-pre-order': 2,
    'pokemon-tcg-mega-set-6-delta-reign-booster-bundle-pre-order': 6,
    'pokemon-30th-celebration-espeon-ex-and-umbreon-ex-battle-deck-bundle-pre-order': 6,
    'app-exclusive-wave-2-pokemon-first-partner-illustration-collections-series-2-pre-order': 6
  };

  /* --- styles: toast + shake animation --- */
  var css = document.createElement('style');
  css.textContent =
    '@keyframes hvShake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}' +
    '30%,50%,70%{transform:translateX(-3px)}40%,60%{transform:translateX(3px)}}' +
    '.hv-limit-shake{animation:hvShake .5s ease both;box-shadow:0 0 0 2px var(---color-error-text,#d02e2e)!important;' +
    'border-radius:7px;transition:box-shadow .3s ease;}' +
    '.hv-limit-violate{animation:hvShake .5s ease both;border-color:var(---color-error-border,#d02e2e)!important;' +
    'color:var(---color-error-text,#d02e2e)!important;transition:border-color .3s ease,color .3s ease;}' +
    '.hv-limit-chip-wrap{width:100%;display:flex;justify-content:center;margin:0 0 5px;}' +
    '.hv-limit-chip{display:inline-flex;align-items:center;margin:0;padding:4px 10px;' +
    'border:1px solid var(---color-border,#000);border-radius:7px;color:var(---color-text,#000);' +
    'font-size:12px;line-height:1.3;font-weight:var(---body-font-weight-bold,700);' +
    'letter-spacing:.04em;text-transform:uppercase;white-space:nowrap;}' +
    '@media (prefers-reduced-motion: reduce){.hv-limit-shake,.hv-limit-violate{animation:none;}}';
  document.head.appendChild(css);

  function toastEl() {
    var el = document.getElementById('hv-qty-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'hv-qty-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText =
        'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);' +
        'max-width:92vw;box-sizing:border-box;padding:10px 20px;' +
        'background:#000;color:#fff;border-radius:7px;' +
        'font-size:14px;line-height:1.45;text-align:center;white-space:pre-line;' +
        'box-shadow:0 4px 16px rgba(0,0,0,.35);z-index:2147483000;' +
        'opacity:0;transition:opacity .25s ease;pointer-events:none;';
      (document.body || document.documentElement).appendChild(el);
    }
    return el;
  }

  function showToast(text) {
    var now = Date.now();
    if (text === lastText && now - lastAt < 1500) return;
    lastText = text; lastAt = now;
    var el = toastEl();
    el.textContent = text;
    el.style.opacity = '1';
    clearTimeout(el.__hvT);
    el.__hvT = setTimeout(function () { el.style.opacity = '0'; }, 4000);
  }

  /* ============ Phase B violation UX ============
     The limit badge is the violation surface — PDP badge above the stepper,
     or the cart line's limit chip — it shakes and flashes error-red while
     the stepper keeps its red ring + shake. The theme's misleading
     "No more inventory available" tooltip is stripped for limit caps. */

  function hvHolder(i) { return i.closest('[data-quantity-holder]'); }

  function hvShowViolation(input) {
    if (!input || !input.hasAttribute || !input.hasAttribute('data-hv-limit-cap')) return false;
    var h = hvHolder(input), hit = false;
    /* the limit badge is the violation surface: PDP badge above the stepper,
       or the cart line's limit note — it shakes and flashes error-red */
    var chip = null;
    var form = input.closest('form');
    if (form) chip = form.querySelector('[data-hv-limit-badge]');
    if (!chip) {
      var cell = input.closest('.cart-product__quantity');
      chip = cell && cell.querySelector('.hv-limit-note');
    }
    if (!chip) {
      var card = input.closest('[data-hv-limit-card]');
      chip = card && card.querySelector('.hv-limit-chip');
    }
    if (chip) {
      chip.classList.remove('hv-limit-violate');
      void chip.offsetWidth;
      chip.classList.add('hv-limit-violate');
      clearTimeout(chip.__hvT);
      chip.__hvT = setTimeout(function () { chip.classList.remove('hv-limit-violate'); }, 4000);
      hit = true;
    }
    if (h) {
      h.classList.remove('hv-limit-shake');
      void h.offsetWidth;
      h.classList.add('hv-limit-shake');
      setTimeout(function () { h.classList.remove('hv-limit-shake'); }, 1300);
      var plus = h.querySelector('[data-quantity-plus]');
      if (plus) setTimeout(function () {
        plus.removeAttribute('data-quantity-tooltip');
        plus.removeAttribute('data-quantity-tooltip-visible');
        plus.removeAttribute('title');
      }, 0);
    }
    return hit;
  }

  /* + pressed at the wall: value can't change, so catch the click itself.
     Swallow the event entirely (capture phase runs before the theme's
     handlers) — otherwise the theme fires a same-quantity /cart/change.js,
     shows its loading state, then its limit banner: shake→load→shake.
     One clean violation moment instead. */
  function hvTarget(ev) {
    /* shadow DOM retargets events at document level — composedPath keeps
       the real origin (StorePass search renders in a shadow tree) */
    return (ev.composedPath && ev.composedPath()[0]) || ev.target;
  }

  document.addEventListener('click', function (ev) {
    var tgt = hvTarget(ev);
    var plus = tgt && tgt.closest && tgt.closest('[data-quantity-plus]');
    if (plus) {
      var h = plus.closest('[data-quantity-holder]');
      var capped = h && h.querySelector('input[data-hv-limit-cap]');
      if (capped) {
        var mx = parseInt(capped.getAttribute('max'), 10);
        var vl = parseInt(capped.value, 10);
        if (!isNaN(mx) && !isNaN(vl) && vl >= mx) {
          ev.preventDefault();
          ev.stopPropagation();
          hvShowViolation(capped);
          return;
        }
      }
    }
    /* remember the stepper the shopper last touched (toast/shake targeting) */
    var b = tgt && tgt.closest && tgt.closest('button, [data-quantity-plus], [data-quantity-minus]');
    if (!b) return;
    var wrap = b.closest('[data-quantity-holder], .product__quantity, .cart__quantity, form, td, div');
    var input = wrap && wrap.querySelector && wrap.querySelector('input[name="quantity"], input[name="updates[]"], input[type="number"]');
    if (input) lastQtyEl = input;
  }, true);

  /* typed overflow: remember the raw value before the clamp rewrites it */
  document.addEventListener('input', function (ev) {
    var t = hvTarget(ev);
    if (t && t.tagName === 'INPUT' && t.hasAttribute('data-hv-limit-cap')) t.__hvRaw = parseInt(t.value, 10);
  }, true);
  document.addEventListener('change', function (ev) {
    var t = hvTarget(ev);
    if (t && t.tagName === 'INPUT' &&
        (t.type === 'number' || t.name === 'quantity' || t.name === 'updates[]')) lastQtyEl = t;
  }, true);

  function shakeQty() {
    var el = lastQtyEl ||
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    if (!el) return;
    var target = el.closest('[data-quantity-holder], .product__quantity') || el;
    target.classList.remove('hv-limit-shake');
    void target.offsetWidth; // restart animation
    target.classList.add('hv-limit-shake');
    setTimeout(function () { target.classList.remove('hv-limit-shake'); }, 1300);
  }

  /* --- TEMPORARY: decorate StorePass-rendered product cards (collection/search
         grids) with a LIMIT chip and tag their inputs, so limited products are
         visible before rejection and hvShowViolation has a surface to flash.
         React owns those steppers, so no hard cap here — the checkout validation
         is the wall. Self-healing via the MutationObserver (re-inserts after
         React re-renders). Remove with HV_LIMITS at StorePass handoff. --- */
  var hvDecorateT = 0;
  function hvDeepLinks() {
    /* product links in the document AND inside any open shadow roots
       (StorePass search results render in a shadow tree) */
    var out = [];
    function collect(root) {
      var found = root.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < found.length; i++) out.push(found[i]);
    }
    collect(document);
    try {
      var walker = document.createTreeWalker(document.documentElement, NodeFilter.SHOW_ELEMENT);
      var n;
      while ((n = walker.nextNode())) {
        if (n.shadowRoot) collect(n.shadowRoot);
      }
    } catch (e) { /* older browsers: document-level links already collected */ }
    return out;
  }
  function hvDecorateCards() {
    var now = Date.now();
    if (now - hvDecorateT < 300) return;
    hvDecorateT = now;
    var links = hvDeepLinks();
    for (var i = 0; i < links.length; i++) {
      var m = /\/products\/([a-z0-9\-]+)/.exec(links[i].getAttribute('href') || '');
      var lim = m && HV_LIMITS[m[1]];
      if (!lim) continue;
      /* climb to the card: nearest ancestor that also contains a number input */
      var node = links[i], card = null, depth = 0;
      while (node && depth < 7) {
        node = node.parentElement; depth++;
        if (node && node.querySelector && node.querySelector('input[type="number"]')) { card = node; break; }
      }
      if (!card) continue;
      /* grid-level false positive guard: a card links to exactly one product */
      var hrefs = {};
      var cardLinks = card.querySelectorAll('a[href*="/products/"]');
      for (var j = 0; j < cardLinks.length; j++) {
        var mm = /\/products\/([a-z0-9\-]+)/.exec(cardLinks[j].getAttribute('href') || '');
        if (mm) hrefs[mm[1]] = true;
      }
      if (Object.keys(hrefs).length !== 1) continue;
      var input = card.querySelector('input[type="number"]');
      if (!input) continue;
      /* Liquid-owned surfaces (PDP buy box, cart lines) render their own
         badge/note below or above the stepper — never double-chip them.
         Decorator-processed cards carry data-hv-limit-card and stay
         eligible so the chip self-heals after React re-renders. */
      if (input.hasAttribute('data-hv-limit-cap') && !card.hasAttribute('data-hv-limit-card')) continue;
      card.setAttribute('data-hv-limit-card', m[1]);
      input.setAttribute('data-hv-limit-cap', lim);
      if (!card.querySelector('.hv-limit-chip')) {
        var wrap = document.createElement('div');
        wrap.className = 'hv-limit-chip-wrap';
        var chipEl = document.createElement('span');
        chipEl.className = 'hv-limit-chip';
        chipEl.textContent = 'Limit ' + lim + ' per customer';
        wrap.appendChild(chipEl);
        var row = input.parentElement || input;
        if (row.parentElement) row.parentElement.insertBefore(wrap, row);
      }
    }
  }
  hvDecorateCards();

  /* --- theme error cleanup: duplicated pink popover (PDP) and the
         "No more products available for purchase" cart banner, which is
         inaccurate for per-customer caps — the line chip owns that message --- */
  var mo = new MutationObserver(function () {
    hvDecorateCards();
    document.querySelectorAll('.popover-error').forEach(function (p) {
      /* v4: the toast owns cart-error messaging on every surface — the
         header popover is invisible on mobile (~4 in 5 of these errors)
         and would double-message on desktop, so hide it for every cart
         error. Targets the transient .popover-error node itself, so the
         container still shows later success popovers. */
      var holder = p.closest('[class*="popover"]') || p;
      holder.style.display = 'none';
    });
    document.querySelectorAll('[data-cart-errors]').forEach(function (banner) {
      var msg = banner.querySelector('[data-error-message]');
      var title = msg && msg.textContent.trim();
      if (!title) return;
      var inputs = document.querySelectorAll('input[data-hv-limit-cap]');
      for (var k = 0; k < inputs.length; k++) {
        var row = inputs[k].closest('[data-item]');
        var t = row && row.querySelector('.cart-product__title');
        if (t && t.textContent.trim() === title) {
          banner.style.display = 'none';
          msg.textContent = '';
          hvShowViolation(inputs[k]);
          return;
        }
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  function collectMessages(j) {
    var out = [];
    function push(v) {
      if (typeof v === 'string' && v.trim() && out.indexOf(v.trim()) === -1) out.push(v.trim());
    }
    if (!j || typeof j !== 'object') return out;
    push(j.description);
    if (j.message && j.message !== 'Cart Error') push(j.message);
    var e = j.errors;
    if (typeof e === 'string') push(e);
    else if (Array.isArray(e)) e.forEach(push);
    else if (e && typeof e === 'object') {
      Object.keys(e).forEach(function (k) {
        var v = e[k];
        if (Array.isArray(v)) { v.forEach(push); } else { push(v); }
      });
    }
    return out;
  }

  var SOLD_OUT_MSG = /is already sold out/;

  /* sold-out 422: the page just proved itself stale — flip the add
     button that produced the click into the theme's genuine Sold Out
     state (same attributes Liquid renders server-side) so it stops
     inviting more clicks. Conservative scope: only the add-to-cart
     form the shopper touched, else the main PDP form. React-owned
     (StorePass) buttons are left alone — React would clobber the
     mutation on re-render; their fix lands with the native build. */
  function hvMarkSoldOut() {
    try {
      var scope = (lastQtyEl && lastQtyEl.closest && lastQtyEl.closest('form[action*="/cart/add"]')) ||
        (/^\/products\//.test(location.pathname) && document.querySelector('form[action*="/cart/add"]'));
      if (!scope) return;
      var btn = scope.querySelector('[data-add-to-cart]') || scope.querySelector('button[name="add"]');
      if (!btn) return;
      btn.setAttribute('disabled', 'disabled');
      var label = (window.theme && theme.translations && theme.translations.sold_out) || 'Sold Out';
      var txt = btn.querySelector('[data-add-to-cart-text]') || btn;
      txt.textContent = label;
    } catch (e) { /* cosmetic only — never break the toast */ }
  }

  function handleBlocked(json, kind) {
    try {
      var msgs = collectMessages(json);
      var isLimit = LIMIT_MSG.test(msgs.join('\n'));
      if (SOLD_OUT_MSG.test(msgs.join('\n'))) {
        msgs = msgs.map(function (m) { return m.replace(/is already sold out/g, 'is now sold out'); });
        hvMarkSoldOut();
      }
      /* v4: route by rejection type. Limit rejections -> the Phase B
         badge/chip is the violation surface (toast only if that surface is
         missing). Inventory rejections (sold out / all remaining stock
         already in cart) -> toast with Shopify's own wording; never flash
         the LIMIT badge for a stock problem. */
      if (!(isLimit && hvShowViolation(lastQtyEl))) {
        showToast(msgs.length ? msgs.slice(0, 3).join('\n')
                              : 'Couldn’t add to cart — item unavailable.');
        shakeQty();
      }
      // Cart page: the theme's change handler has no error path and leaves
      // the row spinning — resync after the shopper has seen the message.
      if (kind !== 'add' && /^\/cart\/?$/.test(location.pathname)) {
        setTimeout(function () { location.reload(); }, 1600);
      }
    } catch (e) { /* never break the page */ }
  }

  function kindFromUrl(url) {
    var m = /\/cart\/(add|change|update)/.exec(url || '');
    return m ? m[1] : '';
  }

  /* --- fetch interceptor (theme + StorePass) --- */
  if (window.fetch) {
    var hvFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '', method = 'GET';
      try {
        url = (input && input.url) ? input.url : String(input || '');
        method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      } catch (e) {}
      var p = hvFetch.apply(this, arguments);
      if (method === 'POST' && CART_MUTATION.test(url)) {
        p.then(function (res) {
          if (res && res.status === 422) {
            res.clone().json().then(function (j) { handleBlocked(j, kindFromUrl(url)); })
              .catch(function () { handleBlocked(null, kindFromUrl(url)); });
          }
        }).catch(function () {});
      }
      return p;
    };
  }

  /* --- XHR interceptor (jQuery $.ajax cart calls) --- */
  if (window.XMLHttpRequest) {
    var hvOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__hvCartKind = (String(method || '').toUpperCase() === 'POST')
          ? kindFromUrl(String(url || '')) : '';
      } catch (e) { this.__hvCartKind = ''; }
      return hvOpen.apply(this, arguments);
    };
    var hvSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__hvCartKind) {
        var kind = this.__hvCartKind;
        this.addEventListener('load', function () {
          if (this.status === 422) {
            var j = null;
            try { j = JSON.parse(this.responseText); } catch (e) {}
            handleBlocked(j, kind);
          }
        });
      }
      return hvSend.apply(this, arguments);
    };
  }

  /* --- cart:add-item dispatch guard: the theme's listener does
         this.cartToggle.classList.add(...) unguarded and crashes on pages
         without [data-cart-toggle] (Noibu: “null is not an object
         (evaluating this.carttoggle.classlist)”, co-timed with every add
         click). The listener only animates that toggle, so on toggle-less
         pages the event has no work to do — swallow it there. Same
         interceptor pattern as the fetch/XHR nets above. Element-level
         dispatches are untouched (override sits on document only). --- */
  var hvDispatch = document.dispatchEvent.bind(document);
  document.dispatchEvent = function (ev) {
    try {
      if (ev && ev.type === 'cart:add-item' && !document.querySelector('[data-cart-toggle]')) {
        return true; /* uncancelled no-op; theme treats dispatch as fire-and-forget */
      }
    } catch (e) { /* fall through to real dispatch */ }
    return hvDispatch(ev);
  };

  /* --- stepper clamp: typed values above max snap back; capped inputs get
         the full violation moment, everything else gets the plain shake --- */
  document.addEventListener('change', function (ev) {
    var t = hvTarget(ev);
    if (!t || t.tagName !== 'INPUT') return;
    var isQty = t.type === 'number' || t.name === 'quantity' || t.name === 'updates[]';
    if (!isQty || !t.hasAttribute('max')) return;
    var max = parseInt(t.getAttribute('max'), 10);
    var min = parseInt(t.getAttribute('min'), 10);
    var val = parseInt(t.value, 10);
    var raw = t.__hvRaw; t.__hvRaw = null;
    if (isNaN(val)) return;
    if (!isNaN(max) && (val > max || (!isNaN(raw) && raw > max))) {
      if (val > max) t.value = max;
      if (!hvShowViolation(t)) shakeQty();
    }
    else if (!isNaN(min) && val < min) { t.value = min; }
  }, true);
})();

/* ============================================================
   Hobbiesville — Add-to-cart confirmation popover (Cowork, 2026-07-08) [v3]
   Shows a compact "Added to your cart" popover under the cart icon on
   EVERY user add — theme product pages AND StorePass grids/search — on
   mobile and desktop. Browser-verified on the staged theme.
   WHY a custom element instead of the theme's native popover: the theme
   popover (a) is gated to viewports >= theme.sizes.mobile (550px) so it
   never fired on phones, (b) is never called by StorePass's own React
   add-to-cart (most of the catalog), and (c) gets hidden by a follow-up
   /cart/update (Order Protect) right after add. Rather than fight all
   three, we hide the theme popover and render our own decoupled element,
   populated from the /cart/add.js response.
   Non-invasive: only reads a CLONE of the cart response — never blocks
   or alters the add (can't slow it down or break it). Only fires after a
   real user click on an add-to-cart control (skips programmatic adds).
   Styling consumes the theme's own tokens (---body-font-family = DIN Next,
   ---color-* ) so it matches the live design automatically.
   Success-path only — 422 cart errors stay owned by the toast net above.
   Supersedes the theme-popover-enable approach. v7: replace with a
   StorePass-native "added to cart" event, or fix in the theme source.
   Removable any time: delete this block (restores theme-native popover).
   ============================================================ */
(function () {
  'use strict';
  if (window.__hvCartPopover) return;
  window.__hvCartPopover = true;

  var CHECK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';

  var st = document.createElement('style');
  st.textContent =
    '.header-cartPopover{display:none !important;}' +
    '#hv-cart-popover{position:fixed;z-index:2147483000;width:196px;box-sizing:border-box;background:var(---color-background,#fff);border:1px solid var(---color-border,#000);padding:11px 14px;opacity:0;transform:translateY(-6px);transition:opacity .28s ease,transform .28s ease;pointer-events:none;font-family:var(---body-font-family),sans-serif;}' +
    '#hv-cart-popover.hv-in{opacity:1;transform:translateY(0);pointer-events:auto;cursor:pointer;}' +
    '#hv-cart-popover .hvp-head{display:flex;align-items:center;justify-content:center;gap:5px;font-weight:var(---body-font-weight-bold,700);font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:var(---color-text,#000);padding-bottom:9px;margin-bottom:9px;border-bottom:1px solid var(---color-border-alpha-8,rgba(0,0,0,.1));}' +
    '#hv-cart-popover .hvp-row{display:flex;align-items:center;gap:11px;}' +
    '#hv-cart-popover .hvp-thumb{flex:0 0 46px;width:46px;height:46px;border:1px solid rgba(0,0,0,.08);background-size:contain;background-repeat:no-repeat;background-position:center;background-color:#f4f2ec;}' +
    '#hv-cart-popover .hvp-info{flex:1 1 0;min-width:0;}' +
    '#hv-cart-popover .hvp-title{font-weight:var(---body-font-weight-bold,700);font-size:13px;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(---color-text,#000);}' +
    '#hv-cart-popover .hvp-variant{font-size:11px;opacity:.55;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(---color-text,#000);}' +
    '#hv-cart-popover .hvp-price{font-weight:900;font-size:13px;margin-top:3px;color:var(---color-text,#000);}' +
    '@media (prefers-reduced-motion:reduce){#hv-cart-popover{transition:opacity .28s ease;transform:none;}#hv-cart-popover.hv-in{transform:none;}}';
  (document.head || document.documentElement).appendChild(st);

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function money(c){return c==null?'':'$'+(c/100).toFixed(2);}

  var el;
  function ensure(){
    if(!el||!document.body.contains(el)){
      el=document.createElement('div');
      el.id='hv-cart-popover';
      el.setAttribute('role','status');
      el.setAttribute('aria-live','polite');
      el.addEventListener('click',function(){window.location.href='/cart';});
      document.body.appendChild(el);
    }
    return el;
  }
  function cartIconRect(){
    var best=null;
    document.querySelectorAll('.js-cartToggle,.cartToggle,[data-cart-toggle],a[href="/cart"]').forEach(function(x){
      var r=x.getBoundingClientRect();
      if(r.width>0&&r.height>0&&r.top<200){ if(!best||r.right>best.right) best=r; }
    });
    return best;
  }
  function anchor(n){
    var r=cartIconRect();
    n.style.left='auto'; n.style.bottom='auto';
    if(r){ n.style.top=Math.round(r.bottom+8)+'px'; n.style.right=Math.max(8,Math.round(window.innerWidth-r.right))+'px'; }
    else { n.style.top='58px'; n.style.right='12px'; }
  }
  function show(item){
    if(!item) return;
    var n=ensure();
    var img=item.image||(item.featured_image&&item.featured_image.url)||'';
    var title=item.product_title||item.title||'';
    var variant=(item.variant_title&&item.variant_title!==null&&item.variant_title!=='null')?item.variant_title:'';
    var price=money(item.final_price!=null?item.final_price:item.price);
    n.innerHTML='<div class="hvp-head"><span style="display:inline-flex;color:var(---color-text,#000)">'+CHECK+'</span>Added to your cart</div>'+
      '<div class="hvp-row"><div class="hvp-thumb"'+(img?' style="background-image:url('+img+')"':'')+'></div>'+
      '<div class="hvp-info"><div class="hvp-title">'+esc(title)+'</div>'+
      (variant?'<div class="hvp-variant">'+esc(variant)+'</div>':'')+
      '<div class="hvp-price">'+price+'</div></div></div>';
    anchor(n);
    void n.offsetWidth;
    n.classList.add('hv-in');
    clearTimeout(n.__t);
    n.__t=setTimeout(function(){ n.classList.remove('hv-in'); }, 4000);
  }

  var pend=0;
  document.addEventListener('click',function(ev){
    var path=(ev.composedPath&&ev.composedPath())||[ev.target];
    for(var i=0;i<path.length;i++){
      var x=path[i]; if(!x||x.nodeType!==1) continue;
      var cn=(typeof x.className==='string')?x.className:'';
      if((x.classList&&(x.classList.contains('store-pass-product-cta')||x.classList.contains('product__form-submit')))||cn.indexOf('store-pass-product-cta')>=0){ pend=Date.now(); return; }
      if(x.matches&&x.matches('[data-add-to-cart],[name="add"],form[action*="/cart/add"] button,form[action*="/cart/add"] [type="submit"]')){ pend=Date.now(); return; }
    }
  },true);

  function onAdd(json){
    if(Date.now()-pend>6000) return;
    pend=0;
    var it=json&&(json.items?json.items[json.items.length-1]:json);
    if(it&&(it.product_title||it.title)){ try{ show(it); }catch(e){} }
  }

  if(window.fetch){
    var of=window.fetch;
    window.fetch=function(i,init){
      var u=(i&&i.url)?i.url:String(i||'');
      var m=((init&&init.method)||(i&&i.method)||'GET').toUpperCase();
      var p=of.apply(this,arguments);
      if(m==='POST'&&/\/cart\/add/.test(u)){
        p.then(function(r){ if(r&&r.status>=200&&r.status<300){ r.clone().json().then(onAdd).catch(function(){}); } }).catch(function(){});
      }
      return p;
    };
  }
  if(window.XMLHttpRequest){
    var oo=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(m,u){ try{ this.__hvAdd=(String(m||'').toUpperCase()==='POST'&&/\/cart\/add/.test(String(u||''))); }catch(e){} return oo.apply(this,arguments); };
    var os=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send=function(){
      if(this.__hvAdd){ this.addEventListener('load',function(){ if(this.status>=200&&this.status<300){ var j=null; try{ j=JSON.parse(this.responseText); }catch(e){} if(j) onAdd(j); } }); }
      return os.apply(this,arguments);
    };
  }
}());